import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { createRoot } from 'react-dom/client';
import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles';

import Graphic from '@arcgis/core/Graphic';

import { theme } from 'library';
import Popup from './Popup';

const buildPin = (hasAffiliateWithSubscription, terminal) => {
  const point = {
    latitude: terminal.latitude,
    longitude: terminal.longitude,
    type: 'point',
  };

  const pinSymbol = {
    height: '26px',
    type: 'picture-marker',
    url: `${process.env.PUBLIC_URL}/icons/map/map-pin.svg`,
    width: '20px',
  };

  const popupNode = document.createElement('div');
  createRoot(popupNode).render(
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <Router>
          <Popup hasAffiliateWithSubscription={hasAffiliateWithSubscription} terminal={terminal} />
        </Router>
      </ThemeProvider>
    </StyledEngineProvider>
  );

  const popupTemplate = {
    content: popupNode,
  };

  const attributes = {
    address: terminal.address,
    city: terminal.city,
    currentWaitTime: terminal.currentWaitTime,
    distance: terminal.distance,
    latitude: terminal.latitude,
    longitude: terminal.longitude,
    state: terminal.state,
    terminalId: terminal.terminalId,
    terminalIdName: terminal.terminalIdName,
    zipcode: terminal.zipcode,
  };

  const pin = new Graphic({
    attributes,
    geometry: point,
    popupTemplate,
    symbol: pinSymbol,
  });

  return pin;
};

export default buildPin;
